import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SectionContainer from "@/App/components/SectionContainer";
import { RootState } from "@/App/reducers";
import { LoadingSkeleton, LoadingSkeletonProvider, Button } from "capitalrx-components";
import { formatDate } from "capitalrx-utilities";
import { defaultDateFormat } from "@/App/constants/constants";

import { getBatchManualClaimActions, downloadBatchManualClaimActions } from "@/App/actions";

interface Props {
  fileID: string;
}

const FileDownload: React.FC<Props> = ({ fileID }: Props) => {
  const dispatch = useDispatch();
  const { batchManualClaim } = useSelector((state: RootState) => state.batchManualClaim);
  const { getManualClaim } = getBatchManualClaimActions;
  const { downloadManualClaim } = downloadBatchManualClaimActions;

  useEffect(() => {
    dispatch(getManualClaim(fileID));
  }, []);

  const { created_at, original_name, status } = batchManualClaim;
  const loading = status === "";

  const handleButtonClick = (): void => {
    dispatch(downloadManualClaim(fileID));
  };

  const downloadButtonContent = (
    <Button buttonStyle="solid" color="darkblue" handleClick={handleButtonClick}>
      <span className="caprx-icon-download" /> Download
    </Button>
  );

  return (
    <LoadingSkeletonProvider loading={loading}>
      <SectionContainer theme="read-only-form-page-wrapper" headerTitle="Output" sectionTitleWithBtn={false}>
        <LoadingSkeleton>
          <div className="download-manual-batch-claim-wrapper">
            <div className="download-manual-batch-claim-header">
              {status !== "processed" ? `File ${original_name} is being processed. We will send an email once this file is completed.` : `File ${original_name} processed.`}
            </div>
            <div>{`Uploaded ${formatDate(created_at, defaultDateFormat)}`}</div>
            {status === "processed" && <div className="mt25">{downloadButtonContent}</div>}
          </div>
        </LoadingSkeleton>
      </SectionContainer>
    </LoadingSkeletonProvider>
  );
};

export default FileDownload;
